import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api, type Geoportal } from '../lib/api';
import { AppNav } from '../components/AppNav';

export function GeoportalsList() {
  const [items, setItems] = useState<Geoportal[]>([]);
  const [creating, setCreating] = useState(false);
  const [form, setForm] = useState({ slug: '', name: '' });

  useEffect(() => {
    api.listGeoportals().then(r => setItems(r.items)).catch(() => {});
  }, []);

  async function create() {
    if (!form.slug || !form.name) return;
    const gp = await api.createGeoportal({ slug: form.slug, name: form.name });
    setCreating(false); setForm({ slug: '', name: '' });
    setItems([gp, ...items]);
  }

  return (
    <div>
      <AppNav />
      <div style={{ padding: 24, maxWidth: 900, margin: '0 auto' }}>
      <header style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <h1>Mis geoportales</h1>
      </header>
      <button onClick={() => setCreating(true)} style={{ padding: '8px 16px', marginBottom: 24 }}>+ Nuevo geoportal</button>
      {creating && (
        <div style={{ border: '1px solid #cbd5e1', padding: 16, borderRadius: 8, marginBottom: 16 }}>
          <input placeholder="slug (a-z, números, -)" value={form.slug} onChange={e => setForm({ ...form, slug: e.target.value })} style={{ width: '100%', padding: 8, marginBottom: 8 }} />
          <input placeholder="Nombre" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} style={{ width: '100%', padding: 8, marginBottom: 8 }} />
          <button onClick={create}>Crear</button>
          <button onClick={() => setCreating(false)} style={{ marginLeft: 8 }}>Cancelar</button>
        </div>
      )}
      <ul style={{ listStyle: 'none', padding: 0 }}>
        {items.map(g => (
          <li key={g.id} style={{ padding: 16, border: '1px solid #e2e8f0', borderRadius: 8, marginBottom: 8 }}>
            <Link to={`/g/${g.id}`} style={{ fontWeight: 600 }}>{g.name}</Link>
            <span style={{ marginLeft: 12, color: '#64748b' }}>/{g.slug}</span>
            <a href={`/v/${g.slug}`} target="_blank" style={{ float: 'right', color: '#0ea5e9' }}>Ver público →</a>
          </li>
        ))}
      </ul>
      </div>
    </div>
  );
}
